// const ENV_MAP = {
//     'oaadmin.qidian.qq.com': 'https://testgateway.qidian.qq.com',
//     'admin.qidian.qq.com': 'https://gateway.qidian.qq.com',
//     'oaprivate.qidian.qq.com': 'https://oaprivate.qidian.qq.com/api'
// };
// const ENV = ENV_MAP[window.location.hostname] || '';

const { envConfig, protocolDomain } = window.QD_LOGIN_COMMON || {};
let gateway = (protocolDomain && protocolDomain.gateway) || '';

if (envConfig && envConfig.private) {
    gateway = `${gateway}/api`;
}

const ENV = gateway;

export default ENV;
